import { createApp } from "vue";
import { PhHeart } from "@phosphor-icons/vue";
import DarkModeToggle from "@/components/DarkModeToggle.vue";
import Sidebar from "@/layout/Sidebar.vue";
import TopNav from "@/layout/TopNav.vue";
import BottomNav from "@/layout/BottomNav.vue";

const components = {
  "ph-heart": PhHeart,
  "dark-mode-toggle": DarkModeToggle,
  sidebar: Sidebar,
  "top-nav": TopNav,
  "bottom-nav": BottomNav,
};

const initVueComponents = function (container) {
  let n = 0;
  for (const tag in components) {
    for (const el of container.querySelectorAll(tag)) {
      const component = Array.isArray(components[tag])
        ? components[tag][0]
        : components[tag];

      const app = createApp({
        name: `${tag} ${++n}`,
        template: el.outerHTML,
      });
      app.component(tag, component);
      app.provide(
        "csrfToken",
        document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content")
      );
      if (Array.isArray(components[tag])) {
        for (const childTag in components[tag][1]) {
          app.component(childTag, components[tag][1][childTag]);
        }
      }
      app.mount(el);
    }
  }
};
initVueComponents(document);
